import { useAsync } from 'react-use';
import { isEmpty } from 'lodash';

import * as Sentry from 'lib/client/sentry/sentry';
import { postRequestOptions } from 'components/ContentReporting/form-utils';
import { getValidSpotifyUriList, isSpotifyUri } from 'components/ContentReporting/validation-utils';
import { CONTENTREPORTINGAPI_URL } from 'containers/ContentReporting/ContentPolicyReporting/utils/constants';
import { ResolveEntityTypeResponse, ResolvedEntityType } from 'proto/generated/inspector_gadget';
import { ENTITY_TYPE_ERRORS } from 'containers/ContentReporting/ContentLegalReporting/utils/constants';

export const useEntityType = (urisValues: string[]) => {
  const {
    value = [],
    loading: isLoading,
    error,
  } = useAsync(async (): Promise<ResolvedEntityType[]> => {
    if (isEmpty(urisValues)) {
      return [];
    }

    const uris = getValidSpotifyUriList(Array.from(new Set(urisValues.filter(isSpotifyUri))));
    const options = postRequestOptions({ uris });

    try {
      const response = await fetch(`${CONTENTREPORTINGAPI_URL}/v1/entity-type`, options);
      if (response.ok) {
        const { resolvedEntityType: urisResolvedEntityType }: ResolveEntityTypeResponse = await response.json();
        return urisResolvedEntityType;
      }

      Sentry.captureException(`Called "/v1/entity-type", Code: ${response.status}; Payload: ${response.body}`);
      throw new Error(ENTITY_TYPE_ERRORS.GENERIC_ERROR);
    } catch (e: unknown) {
      Sentry.captureException(`Error under useAssociatedContent: ${JSON.stringify(e)}`);
      throw new Error(ENTITY_TYPE_ERRORS.GENERIC_ERROR);
    }
  }, [urisValues]);

  return {
    isLoading,
    error,
    resolvedEntityType: value,
  };
};

export default useEntityType;
